import React from 'react';
import {MasterLayout} from 'components/layouts';
import {CMSContent} from 'components/cms';
import {asyncConnect} from 'redux-connect';
import CONFIG from 'base/constants/config';
import {Articles} from 'api';

@asyncConnect([
  {
    key: 'article',
    promise: ({
      match: {
        params: {
          slug
        }
      },
      store: {
        dispatch
      },
      helpers
    }) => {
      let params = {
        filter: {
          where: {
            slug: slug
          }
        }
      };

      return Articles.actions.list.request(params).then(response => {
        if (response.data.length > 0) {
          let description = response.data[0].content.replace(/<(.|\n)*?>/g, '');
          dispatch({
            type: 'SEO_INFO',
            data: {
              title: response.data[0].title,
              // TODO: using limit words by charactor
              description: description.substring(0, 300),

              // TODO: Use custom SEO image
              image: `${CONFIG.UploadImageURL}/03708aed6ad48b41b843785cf1d0d3de.jpg`
            }
          });

          return Promise.resolve(response.data[0]);
        }
      });
    }
  }
])
class CMSPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = this.props.article ? this.props.article.title : 'Vitrade';
    setTimeout(() => window.scrollTo(0, 0), 100);
  }

  render() {
    return (
      <MasterLayout>
        {this.props.article && <CMSContent article={this.props.article}/>}
      </MasterLayout>
    );
  }
}

export default CMSPage;



// WEBPACK FOOTER //
// ./pages/CMSPage.jsx